export const transformDocumentPath = (incomingPath?: string): string => {
  if (!incomingPath) return '';

  const [, id, queryString] =
    incomingPath?.match(/\/admin-documents\/([^?]+)\??(.*)/) || [];
  if (!id) return incomingPath;

  const params = new URLSearchParams(queryString);
  const path = params.get('path') === 'all' ? '' : params.get('path') || '';

  return `/admin/${id}/documents?path=${path}`;
};
